import React from 'react';
import { AiOutlineMail } from 'react-icons/ai';
import {
  SidebarPagesIcon,
  SidebarCalendarIcon,
  SidebarDashboardIcon,
  TwoUsersIcon,
  ClosureIcon,
  OperatorIcon,
  DutyIcon,
  NotificationIcon,
} from '../../config/icon.config';

const options = [
  // {
  //   key: 'charts',
  //   label: 'sidebar.charts',
  //   leftIcon: <SidebarChartsIcon size={19} />,
  //   children: [
  //     {
  //       key: 'googleChart',
  //       label: 'sidebar.googleCharts',
  //     },
  //     {
  //       key: 'reecharts',
  //       label: 'sidebar.recharts',
  //     },
  //     {
  //       key: 'reactChart2',
  //       label: 'sidebar.reactChart2',
  //     },
  //     {
  //       key: 'frappeChart',
  //       label: 'sidebar.frappeChart',
  //     },
  //   ],
  // },
  // {
  //   key: 'Forms',
  //   label: 'sidebar.forms',
  //   leftIcon: <SidebarFormsIcon size={19} />,
  //   children: [
  //     {
  //       key: 'InputField',
  //       label: 'sidebar.input',
  //     },
  //     {
  //       key: 'editor',
  //       label: 'sidebar.editor',
  //     },
  //     {
  //       key: 'FormsWithValidation',
  //       label: 'sidebar.formsWithValidation',
  //     },
  //     {
  //       key: 'progress',
  //       label: 'sidebar.progress',
  //     },
  //     {
  //       key: 'button',
  //       label: 'sidebar.button',
  //     },
  //     {
  //       key: 'tab',
  //       label: 'sidebar.tab',
  //     },
  //     {
  //       key: 'checkbox',
  //       label: 'sidebar.checkbox',
  //     },
  //     {
  //       key: 'radiobox',
  //       label: 'sidebar.radiobox',
  //     },
  //     {
  //       key: 'selectbox',
  //       label: 'sidebar.selectbox',
  //     },
  //     {
  //       key: 'transfer',
  //       label: 'sidebar.transfer',
  //     },
  //     {
  //       key: 'autocomplete',
  //       label: 'sidebar.autocomplete',
  //     },
  //     {
  //       key: 'stepperForms',
  //       label: 'sidebar.stepperForms',
  //     },
  //   ],
  // },
  // {
  //   key: 'uielements',
  //   label: 'sidebar.uiElements',
  //   leftIcon: <SidebarUIIcon size={19} />,
  //   children: [
  //     {
  //       key: 'op_badge',
  //       label: 'sidebar.badge',
  //     },
  //     {
  //       key: 'op_card',
  //       label: 'sidebar.card2',
  //     },
  //     {
  //       key: 'op_carousel',
  //       label: 'sidebar.corusel',
  //     },
  //     {
  //       key: 'op_collapse',
  //       label: 'sidebar.collapse',
  //     },
  //     {
  //       key: 'op_popover',
  //       label: 'sidebar.popover',
  //     },
  //     {
  //       key: 'op_tooltip',
  //       label: 'sidebar.tooltip',
  //     },
  //     {
  //       key: 'op_tag',
  //       label: 'sidebar.tag',
  //     },
  //     {
  //       key: 'op_timeline',
  //       label: 'sidebar.timeline',
  //     },
  //     {
  //       key: 'dropdown',
  //       label: 'sidebar.dropdown',
  //     },
  //     {
  //       key: 'pagination',
  //       label: 'sidebar.pagination',
  //     },
  //     {
  //       key: 'rating',
  //       label: 'sidebar.rating',
  //     },
  //     {
  //       key: 'tree',
  //       label: 'sidebar.tree',
  //     },
  //     {
  //       key: 'swiperslider',
  //       label: 'sidebar.swiperslider',
  //     },
  //   ],
  // },
  // {
  //   key: 'advancedUielements',
  //   label: 'sidebar.advancedElements',
  //   leftIcon: <SidebarAdvancedIcon size={19} />,
  //   children: [
  //     {
  //       key: 'reactDates',
  //       label: 'sidebar.reactDates',
  //     },
  //     {
  //       key: 'codeMirror',
  //       label: 'sidebar.codeMirror',
  //     },
  //     {
  //       key: 'uppy',
  //       label: 'sidebar.uppy',
  //     },
  //     {
  //       key: 'dropzone',
  //       label: 'sidebar.dropzone',
  //     },
  //   ],
  // },
  // {
  //   key: 'feedback',
  //   label: 'sidebar.feedback',
  //   leftIcon: <SidebarFeedbackIcon size={19} />,
  //   children: [
  //     {
  //       key: 'alert',
  //       label: 'sidebar.alert',
  //     },
  //     {
  //       key: 'modal',
  //       label: 'sidebar.modal',
  //     },
  //     {
  //       key: 'message',
  //       label: 'sidebar.message',
  //     },
  //     {
  //       key: 'notification',
  //       label: 'sidebar.notification',
  //     },
  //     {
  //       key: 'popConfirm',
  //       label: 'sidebar.popConfirm',
  //     },
  //     {
  //       key: 'spin',
  //       label: 'sidebar.spin',
  //     },
  //   ],
  // },
  // {
  //   key: 'table',
  //   label: 'sidebar.tables',
  //   leftIcon: <SidebarTablesIcon size={19} />,
  //   children: [
  //     {
  //       key: 'table_ant',
  //       label: 'sidebar.antTables',
  //     },
  //   ],
  // },
  // {
  //   key: 'pages',
  //   label: 'sidebar.pages',
  //   leftIcon: <SidebarPagesIcon size={19} />,
  //   children: [
  //     {
  //       key: '404',
  //       label: 'sidebar.404',
  //       withoutDashboard: true,
  //     },
  //     {
  //       key: '500',
  //       label: 'sidebar.500',
  //       withoutDashboard: true,
  //     },
  //     {
  //       key: 'signin',
  //       label: 'sidebar.signIn',
  //       withoutDashboard: true,
  //     },
  //     {
  //       key: 'signup',
  //       label: 'sidebar.signUp',
  //       withoutDashboard: true,
  //     },
  //     {
  //       key: 'forgotpassword',
  //       label: 'sidebar.forgotPw',
  //       withoutDashboard: true,
  //     },
  //     {
  //       key: 'resetpassword',
  //       label: 'sidebar.resetPw',
  //       withoutDashboard: true,
  //     },
  //   ],
  // },
  // {
  //   key: 'blank_page',
  //   label: 'sidebar.blankPage',
  //   leftIcon: <SidebarBlankIcon size={19} />,
  // },
  {
    key: 'dashboard',
    label: 'sidebar.dashboard',
    leftIcon: <SidebarDashboardIcon size={19} />,
  },
  {
    key: 'calendar',
    label: 'sidebar.calendar',
    leftIcon: <SidebarCalendarIcon size={19} />,
  },
  {
    key: 'customer',
    label: 'sidebar.customer',
    leftIcon: <TwoUsersIcon size={19} />,
  },
  {
    key: 'pages',
    label: 'sidebar.store',
    leftIcon: <SidebarPagesIcon size={19} />,
    children: [
      {
        key: 'workHours',
        label: 'sidebar.workHours',
        leftIcon: <DutyIcon size={19} />,
      },
      {
        key: 'duty',
        label: 'sidebar.duty',
        leftIcon: <DutyIcon size={19} />,
      },
      {
        key: 'operator',
        label: 'sidebar.operator',
        leftIcon: <OperatorIcon size={19} />,
      },
      {
        key: 'closure',
        label: 'sidebar.closure',
        leftIcon: <ClosureIcon size={19} />,
      },
      {
        key: 'operatorUnavailability',
        label: 'sidebar.operatorUnavailability',
        leftIcon: <ClosureIcon size={19} />,
      },
    ],
  },
  {
    key: 'message',
    label: 'sidebar.message',
    leftIcon: <AiOutlineMail size={19} />,
    children: [
      {
        key: 'communication',
        label: 'sidebar.communication',
        leftIcon: <NotificationIcon size={19} />,
      },
      {
        key: 'notification',
        label: 'sidebar.notification',
        leftIcon: <NotificationIcon size={19} />,
      },
    ],
  },
];
export default options;
